import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

function ListadoOrdenesCompra() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-91);

    let comp30 = new Date();
  comp30.setDate(comp30.getDate() -30 );
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  let compromiso30 = moment(comp30).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [artOC, setArtOC] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedFechaCompInicio, setSelectedFechaCompInicio] = useState("");
  const [selectedFechaCompFin, setSelectedFechaCompFin] = useState("");

  const [fecha, setFecha] = useState("");
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_cantidad, setTotalCantidad] = useState("");
  const [tipoCambio, setTipoCambio] = useState(0);
  const [noFactura, setNoFactura] = useState("");
  const [laredo, setLaredo] = useState("No");
  const [modalCxPLaredo, setModalCxPLaredo] = useState(false);
  const [ocLaredo, setOcLaredo] = useState(null);
  const [articulosLaredo, setArticulosLaredo] = useState([]);
  const [selectedArticulosLaredo, setSelectedArticulosLaredo] = useState([]);
  const [numero_orden, setNumeroOrden] = useState("");
  const [moneda, setMoneda] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [modalEditArticulosPI, setModalEditArticulosPI] = useState(false);
  const toggleEditArticulosPI = () => setModalEditArticulosPI(!modalEditArticulosPI);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
  const [totalCaptura, setTotalCaptura] = useState(1);

  // const [inputFields, setInputFields] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      nombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [modalGastos, setModalGastos] = useState(false);
  const toggleGastos = () => setModalGastos(!modalGastos);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const toggleCxPLaredo = () => setModalCxPLaredo(!modalCxPLaredo);

  const [status, setStatus] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_ORDENES_COMPRA}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idOrdenCompra,
              activo: a.is_active,
              fecha: a.fecha,
              plazo: a.plazo,
              fecha_compromiso: a.fecha_compromiso,
              observaciones: a.observaciones,
              total_general: a.total_general,
              proveedores: a.proveedores[0].razon_social,
              idProveedores: a.proveedores[0]._id,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              idUser: a.user[0]._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              embarcado: a.embarcado,
              moneda: a.moneda,
              autorizado: a.autorizado,
              tipoCambio: a.tipoCambio || 0,
              noFactura: a.noFactura || "",
              laredo: a.laredo || "No",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setOrdenesCompra(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, status]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Status: a.status,
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedor,
          Observaciones: a.observaciones,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
          Moneda: a.moneda
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCompra";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCompra",
        sheetFilter: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
        sheetHeader: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCompra.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Compra.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    total_cantidad,
    total_general,
    observaciones,
    numero_orden,
    idEdit,
    tipoCambio,
    noFactura,
    laredo,
  ) {
    setFecha(fecha);
    setPlazo(plazo);
    setFechaCompromiso(fecha_compromiso);
    setSelectedProveedorEdit(idProveedores);
    setTotalCantidad(total_cantidad);
    setTotalGeneral(total_general);
    setObservaciones(observaciones);
    setNumeroOrden(numero_orden);
    setIdEdit(idEdit);
    setTipoCambio(tipoCambio || 0);
    setNoFactura(noFactura || "");
    setLaredo(laredo || "No");
    toggleEdit();
  }

  function jalaInfoGastos(oc) {
    setIdEdit(oc._id);
    setNumeroOrden(oc.numero);
    setTipoCambio(oc.tipoCambio || 0);
    setNoFactura(oc.noFactura || "");
    setLaredo(oc.laredo || "No");
    toggleGastos();
  }

  function editGastosOC() {
    axios.patch(
      `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`,
      {
        tipoCambio: parseFloat(tipoCambio) || 0,
        noFactura,
        laredo,
      },
      { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
    ).then(() => {
      toggleGastos();
      Swal.fire("Good job!", "Gastos actualizados", "success");
      setTimeout(() => window.location.reload(), 1000);
    }).catch((err) => {
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${err.response?.data}` });
    });
  }

  function abrirCxPLaredo(oc) {
    setOcLaredo(oc);
    setSelectedArticulosLaredo([]);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${oc._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setArticulosLaredo(res.data.map((a) => ({
          _id: a._id,
          nombre: a.articulos[0]?.nombre || "",
          SKU: a.articulos[0]?.SKU || "",
          cantidad: a.cantidad,
          precio: a.precio,
          total: a.total,
          checked: true,
        })));
        toggleCxPLaredo();
      })
      .catch((err) => console.log(err));
  }

  function crearCxPLaredo() {
    const seleccionados = articulosLaredo.filter((a) => a.checked);
    const total_cant = seleccionados.reduce((s, a) => s + a.cantidad, 0);
    const tc = ocLaredo?.tipoCambio || 1;
    const total_costo = seleccionados.reduce((s, a) => s + (a.precio * a.cantidad * tc), 0);
    const hoyStr = new Date().toISOString().split("T")[0];
    axios
      .post(URL_NOTAS_CXP, {
        proveedores: ocLaredo.idProveedores,
        ordenesCompra: ocLaredo._id,
        total_cantidad: total_cant,
        total_costo: total_costo,
        saldo: total_costo,
        fecha: hoyStr,
      }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        toggleCxPLaredo();
        Swal.fire("Good job!", "CxP Bodega USA creado con éxito", "success");
      })
      .catch((err) => console.log(err));
  }

  async function ExcelOCMigracion(
    numero,
    idPDFOC,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              // Articulo: a.articulos[0].SKU,
              // Pack: a.pack,
              // TallasColores: a.tallasColores,
              // Cantidad: a.cantidad,
              // Precio: a.precio,
              // Total: a.total,
              articulosOrden: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              cantidadOC: a.cantidad,
              // costo: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
            sheetHeader: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // async function ExcelOCPI(
  //   numero,
  //   idPDFOC
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             IdItem: a._id,
  //             SKU: a.articulos[0].SKU,
  //             Nombre: a.articulos[0].nombre,
  //             Precio: a.precio,
  //             PiezasPorCaja: a.articulos[0].piezasPorCaja,
  //             CBM: a.cbm,
  //             Cajas: (a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2),
  //             Cantidad: a.cantidad,
  //             ValorTotal: a.cantidad * a.precio,
  //             TotalCBM: a.cbm * a.cantidad
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       var option = {};
  
  //       option.fileName = `OC-${numero}`;
    
  //       option.datas = [
  //         {
  //           sheetData: dataFinal,
  //           sheetName: `OC-${numero}`,
  //           sheetFilter: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //           sheetHeader: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //         },
  //       ];
    
  //       var toExcel = new ExportJsonExcel(option);
  //       toExcel.saveExcel();
       
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }


async function ExcelOCPI(numero, idPDFOC) {
  try {
    const response = await axios.get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data;
    let arrayTabla = allArticulosOrden.map((a) => {
      return {
        IdItem: a._id,
        SKU: a.articulos[0].SKU,
        Nombre: a.articulos[0].nombre,
        Precio: a.precio,
        PiezasPorCaja: a.articulos[0].piezasPorCaja,
        CBM: a.cbm,
        Cajas: parseFloat((a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2)),
        Moneda: a.ordenesCompra[0].proveedores[0].moneda,
        // Cantidad: a.cantidad,
        // ValorTotal: a.cantidad * a.precio,
        // TotalCBM: a.cbm * a.cantidad
      };
    }).filter(el => el != null);

    let dataFinal = arrayTabla.map((item, index) => ({
      ...item,
      // Aquí puedes definir las fórmulas en el formato de Excel
      Cantidad: { f: `E${index + 2} * G${index + 2}` },
      ValorTotal: { f: `D${index + 2} * H${index + 2}` }, // Ejemplo de fórmula
      TotalCBM: { f: `F${index + 2} * H${index + 2}` },
    }));

    let worksheet = XLSX.utils.json_to_sheet(dataFinal, {
      header: [
        "IdItem",
        "SKU",
        "Nombre",
        "Precio",
        "PiezasPorCaja",
        "CBM",
        "Cajas",
        "Cantidad",
        "ValorTotal",
        "TotalCBM",
        "Moneda",
      ]
    });

    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `OC-${numero}`);
    
    XLSX.writeFile(workbook, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}

async function ExcelOCPIIngles(numero, idPDFOC) {
  try {
    const response = await axios.get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data;
    let arrayTabla = allArticulosOrden.map((a) => {
      return {
        IdItem: a._id,
        SKU: a.articulos[0].SKU,
        Name: a.articulos[0].nombre,
        Price: a.precio,
        PicesPerBox: a.articulos[0].piezasPorCaja,
        CBM: a.cbm,
        Boxes: parseFloat((a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2)),
        Currency: a.ordenesCompra[0].proveedores[0].moneda,
        // Cantidad: a.cantidad,
        // ValorTotal: a.cantidad * a.precio,
        // TotalCBM: a.cbm * a.cantidad
      };
    }).filter(el => el != null);

    let dataFinal = arrayTabla.map((item, index) => ({
      ...item,
      // Aquí puedes definir las fórmulas en el formato de Excel
      Quantity: { f: `E${index + 2} * G${index + 2}` },
      TotalValue: { f: `D${index + 2} * H${index + 2}` }, // Ejemplo de fórmula
      TotalCBM: { f: `F${index + 2} * H${index + 2}` },
    }));

    let worksheet = XLSX.utils.json_to_sheet(dataFinal, {
      header: [
        "IdItem",
        "SKU",
        "Name",
        "Price",
        "PicesPerBox",
        "CBM",
        "Boxes",
        "Quantity",
        "TotalValue",
        "TotalCBM",
        "Currency",
      ]
    });

    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `OC-${numero}`);
    
    XLSX.writeFile(workbook, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}
  async function ExcelOC(
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              IdItem: a._id,
              SKU: a.articulos[0].SKU,
              Item: a.articulos[0].nombre,  
              OrderedPieces: a.cantidad,
              UnitPrice: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
            sheetHeader: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

async function PDFOC(
  fecha,
  plazo,
  fecha_compromiso,
  idProveedores,
  proveedores,
  user,
  total_cantidad,
  total_general,
  moneda,
  observaciones,
  numero,
  idPDFOC,
) {
  await axios
    .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then(async (response) => {
      let allArticulosOrden = response.data;

      let arrayTabla = allArticulosOrden.map((a) => ({
        id: a._id,
        articulos: a.articulos[0].SKU + "  " + a.articulos[0].nombre,
        skuProv: a.articulos[0].codigo,
        cantidad: a.cantidad,
        precio: a.precio,
        total: a.total,
        pendiente_embarcar: a.pendiente_embarcar,
        idArticulo: a.articulos[0]._id,
        foto: "",
      }));

      let dataFinal = Object.values(arrayTabla);

      // 🔹 Obtener imágenes
      await Promise.all(
        dataFinal.map(async (z) => {
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
          try {
            const data = await axios.get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            });
            z.foto = data.data.secure_url || process.env.PUBLIC_URL + "sinImagen.png";
          } catch {
            z.foto = process.env.PUBLIC_URL + "sinImagen.png";
          }
        })
      );

      // 🔹 Generar PDF
      const doc = new jsPDF("landscape");
      doc.setFontSize(12);
      doc.text(`PO # ${numero}`, 20, 20);
      doc.text(`Date ${fecha}`, 20, 25);
      doc.text(`Supplier ${proveedores}`, 20, 30);

      const data = dataFinal.map((a) => [
        a.foto,
        a.skuProv,
        a.articulos,
        new Intl.NumberFormat("en-US").format(a.cantidad),
        "$" + new Intl.NumberFormat("en-US").format(a.precio),
        "$" + new Intl.NumberFormat("en-US").format(a.total),
      ]);

      doc.autoTable({
        columnStyles: {
          0: { fontSize: 0.0001, cellWidth: 25 },
        },
        head: [["Photo", "SKU Supplier", "SKU Costumer", "Quantity", "Price", "Total"]],
        body: data,
        bodyStyles: { rowHeight: 22 },
        startY: 35,
        didDrawCell: function (data) {
          if (data.column.index === 0 && data.cell.section === "body") {
            const img = data.cell.raw;
            const { x, y } = data.cell;
            doc.addImage(img, x, y, 20, 20);
          }
        },
        foot: [
          [
            "",
            "",
            "Total",
            new Intl.NumberFormat("en-US").format(total_cantidad),
            "",
            "$" + new Intl.NumberFormat("en-US").format(total_general),
          ],
        ],
        footStyles: {
          fontSize: 12,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
        },
        showFoot: "lastPage",
      });

      // 🔹 Agregar observaciones debajo de la tabla
      const finalY = doc.lastAutoTable.finalY + 10; // espacio adicional
      doc.setFontSize(11);
      doc.text("Observations:", 20, finalY);
      doc.setFontSize(10);
      doc.text(observaciones || "No observations.", 20, finalY + 6, {
        maxWidth: 250,
      });

      // 🔹 Abrir PDF
      window.open(doc.output("bloburl"), "_blank");
      // doc.save(`OC-${numero}.pdf`);
    })
    .catch((err) => console.log(err));
}


  function editOrdenes(event) {
    event.preventDefault();
    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            fecha,
            plazo,
            fecha_compromiso,
            proveedores: selectedProveedorEdit,
            total_cantidad,
            total_general,
            observaciones,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Orden deCompra",
            detalle: `${numero_orden} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Fecha Compromiso", field: "fecha_compromiso", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    // { name: "Embarcado", field: "embarcado", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Moneda", field: "moneda", sortable: true },
    { name: "TC", field: "tipoCambio", sortable: true },
    { name: "Factura", field: "noFactura", sortable: true },
    { name: "Bodega USA", field: "laredo", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.moneda.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.embarcado.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedFechaCompInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso >= selectedFechaCompInicio
      );
    }

    if (selectedFechaCompFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso <= selectedFechaCompFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      // sorting.field != "embarcado" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    selectedProveedor,
  ]);
// console.log("hola", articulosOrden)
  function EditArticulos(idOC, numero_orden) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
        gastosEnvio: 0,
        gastosImportacion: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoUSD,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
              gastosEnvio: a.gastosEnvio || 0,
              gastosImportacion: a.gastosImportacion || 0,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }
console.log("hola", articulosOrden) 
  function EditArticulosPI(idOC, numero_orden, moneda) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    setMoneda(moneda);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoUSD,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulosPI();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let PR =
          parseFloat(i.pendiente_embarcar) -
          parseFloat(i.cantidad) +
          parseFloat(event.target.value);
        i.pendiente_embarcar = PR;
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
        gastosEnvio: 0,
        gastosImportacion: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        let FOB = a.costoUSD;
        let nombre = a.nombre;
        handleChangeInputArticulo(id, idArticulo, FOB, nombre);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, nombre) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.nombre = nombre;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.precio = FOB;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosOrden.length;

    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            total_general: total_general_edit,
            total_cantidad: total_cantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_OC,
                  {
                    ordenesCompra: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    embarcado: 0,
                    pendiente_embarcar: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Editar Orden de Compra",
                          detalle: `${numero_orden}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Editar Orden de Compra",
                      detalle: `${numero_orden}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosOrden.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                  // pendiente_embarcar: parseFloat(a.pendiente_embarcar),
                  ajusteAcumulado: parseFloat(a.cantidad - a.cantidadAnterior),
                  gastosEnvio: parseFloat(a.gastosEnvio) || 0,
                  gastosImportacion: parseFloat(a.gastosImportacion) || 0,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Orden de Compra",
                        detalle: `${numero_orden}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function excelInfoArt() {

    axios
    .get(`${URL_ARTICULOS_OC}FindAllInfoArt`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allInfoArt = response.data;

      const dataExcel = allInfoArt.map((a) => {
          return {
            Articulo: a.codigo,
            Cantidad: a.cantidad,
            Embarcado: a.embarcado,
            PendienteEmbarcar: a.pendiente_embarcar,
          };
      });
      const dataExportExcel = Object.values(dataExcel);
      const dataExcelLimpia = dataExportExcel.filter(function (el) {
        return el != null;
      });
  
      var option = {};
  
      option.fileName = "Info Articulos OC";
  
      option.datas = [
        {
          sheetData: dataExcelLimpia,
          sheetName: "Info Articulos OC",
          sheetFilter: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
          sheetHeader: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
        },
      ];
  
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });

  
  }

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Autorizado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

      function importarArchivo(event) {
  const target = event.target;
  const name = target.name;
  let hojas = [];

  if (name === "file") {
    let reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onloadend = (e) => {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach(function (sheetName) {
        var XL_row_object = XLSX.utils.sheet_to_json(
          workbook.Sheets[sheetName]
        );
        hojas.push({
          data: XL_row_object,
          sheetName,
        });
      });

      let A1 = hojas[0].data;
      let TC = totalCaptura;

      A1.forEach((a) => {
        TC = TC + 1;
        setTotalCaptura(TC);

        const cantidad = a.Cantidad || a.Quantity || 0;
        const precio = a.Precio || a.Price || 0;
        const total = cantidad * precio;
        const pendiente_embarcar = cantidad;
        const cbm = a.CBM || a.Cbm || a.cbm || 0;

        const existingItemIndex = articulosOrden.findIndex(item => item.id === a.IdItem);

        const itemData = {
          cantidad,
          precioOrigonal: articulosOrden.precioOriginal,
          precio,
          total,
          embarcado: 0,
          pendiente_embarcar,
          cbm,
        };

        if (existingItemIndex !== -1) {
          articulosOrden[existingItemIndex] = {
            ...articulosOrden[existingItemIndex],
            ...itemData,
          };
        } else {
          articulosOrden.push({
            id: uuidv4(),
            articulos: a.IdItem,
            ...itemData,
          });
        }
      });

      ActualizaTotales();
    };
  }
}


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.oc_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCompraCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              {/* {user.compras_create ? (
                <Button
                  size="sm"
                  color="warning"
                  href="/ComprasCreate"
                >
                  <i className="fas fa-warehouse" style={{ marginRight: 4 }} />Crear Entrada
                </Button>
              ) : (
                <Button size="sm" color="warning" disabled>
                  <i className="fas fa-warehouse" style={{ marginRight: 4 }} />Crear Entrada
                </Button>
              )} */}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelInfoArt}
                >
                  Excel Info Art <i class="far fa-file-excel"></i>
                </Button> */}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Compra</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label>Status</Label>
              <Input
                bsSize="sm"
                type="select"
                value={status}
                required
                onChange={(e) => {
                  setStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        (a.fecha_compromiso < endDate ||
                          a.fecha_compromiso < compromiso30) &&
                        a.status == "Abierto"
                          ? { backgroundColor: "#ed8c8c" }
                          : // : a.fechaCompromiso > compromiso30
                            // ? { backgroundColor: "#fcf260"  }
                            // : { backgroundColor: "#64e379" }
                            undefined
                      }
                    >
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.fecha_compromiso}</td>
                      <td>{a.proveedores}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.total_cantidad
                        )}
                      </td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US").format(a.embarcado)}
                      </td> */}
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.total_general
                          )}{" "}
                      </td>
                      <td>{a.moneda}</td>
                      <td>{a.tipoCambio > 0 ? new Intl.NumberFormat("en-US", {minimumFractionDigits:2}).format(a.tipoCambio) : "-"}</td>
                      <td>{a.noFactura || "-"}</td>
                      <td style={{color: a.laredo === "Si" ? "#10b981" : undefined, fontWeight: a.laredo === "Si" ? "bold" : undefined}}>{a.laredo}</td>
                      <td>
                        {user.menu_compras ? (
                          <div>
                            {user.menu_compras && a.autorizado == "No" ? (
                              <span>
                                <Button
                                  color="primary"
                                  // id="Baja"
                                  onClick={(e) => autorizar(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              </span>
                            ) : undefined}

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.plazo,
                                  a.fecha_compromiso,
                                  a.idProveedores,
                                  a.proveedores,
                                  a.user,
                                  a.total_cantidad,
                                  a.total_general,
                                  a.moneda,
                                  a.observaciones,
                                  a.numero,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOC(a.numero, a._id)}
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPI(a.numero, a._id)}
                            >
                              PI E
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPIIngles(a.numero, a._id)}
                            >
                              PI I
                            </Button> */}

                            {/* <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                            /> 
                             <BajaAltaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />*/}
                            <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={
                                process.env.REACT_APP_URL_ORDENES_COMPRA
                              }
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />
                          </div>
                        ) : undefined}
                      </td>
                      <td>
                        {a.status == "Abierto" && a.activo == "Si" ? (
                          <div>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fecha,
                                  a.plazo,
                                  a.fecha_compromiso,
                                  a.idProveedores,
                                  a.total_cantidad,
                                  a.total_general,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.tipoCambio,
                                  a.noFactura,
                                  a.laredo,
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => EditArticulos(a._id, a.numero)}
                            >
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button
                              color="warning"
                              size="sm"
                              title="Gastos / TC / Factura"
                              onClick={() => jalaInfoGastos(a)}
                            >
                              <i class="fas fa-dollar-sign"></i>
                            </Button>
                            <Button
                              color="success"
                              size="sm"
                              title="Crear Recepción Bodega USA"
                              href={`/RecepcionLaredoCreate?oc=${a._id}`}
                            >
                              <i class="fas fa-plane-arrival"></i>
                            </Button>
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button color="warning" size="sm" disabled>
                              <i class="fas fa-dollar-sign"></i>
                            </Button>
                            <Button color="success" size="sm" disabled>
                              <i class="fas fa-plane-arrival"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Orden de Compra {numero_orden}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedProveedorEdit}
                required
                onChange={(e) => {
                  setSelectedProveedorEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona un Proveedor</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="text"
                placeholder="Plazo"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Compromiso</Label>
              <Input
                type="date"
                placeholder="Fecha Compromiso"
                value={fecha_compromiso}
                required
                onChange={(e) => {
                  setFechaCompromiso(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editOrdenes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalGastos} toggle={toggleGastos}>
        <ModalHeader toggle={toggleGastos}>
          <h5>Gastos OC #{numero_orden}</h5>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>T.C. (USD→MXN)</Label>
              <Input type="number" min="0" step="0.01" value={tipoCambio}
                onChange={(e) => setTipoCambio(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>No. Factura</Label>
              <Input type="text" value={noFactura}
                onChange={(e) => setNoFactura(e.target.value)} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <Label>Bodega USA</Label>
              <Input type="select" value={laredo}
                onChange={(e) => setLaredo(e.target.value)}>
                <option value="No">No</option>
                <option value="Si">Si</option>
              </Input>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editGastosOC}>Guardar</Button>
          <Button color="secondary" onClick={toggleGastos}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>Editar Articulos OC {numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US").format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">SKU</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Nombre</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Precio USD</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">G. Envío USD</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">G. Import. MXN</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden
            .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
            .map((ao) => (
              <div key={ao.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={ao.articulos}
                      required
                      onChange={(event) => {
                        BuscaArticuloExistentes(ao.id, event);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {articulos
                        .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.SKU}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="nombre"
                      type="text"
                      placeholder="nombre"
                      value={ao.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={ao.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentesCantidad(ao.id, event)
                      }
                    />
                  </Col>
                  {/* <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="embarcado"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="embarcado"
                      value={ao.embarcado}
                      required
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="pendiente_embarcar"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="pendiente_embarcar"
                      value={ao.pendiente_embarcar}
                      required
                      disabled
                    />
                  </Col> */}

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={ao.precio}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="gastosEnvio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="G. Envío USD"
                      value={ao.gastosEnvio}
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="gastosImportacion"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="G. Import. MXN"
                      value={ao.gastosImportacion}
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={ao.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="nombre"
                    type="text"
                    placeholder="nombre"
                    value={inputField.nombre}
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col> */}

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    name="gastosEnvio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="G. Envío USD"
                    value={inputField.gastosEnvio}
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    name="gastosImportacion"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="G. Import. MXN"
                    value={inputField.gastosImportacion}
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US").format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulosPI}
        toggle={toggleEditArticulosPI}
      >
        <ModalHeader toggle={toggleEditArticulosPI}>
          <h4>Subir PI OC #{numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US").format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">CBM</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio Original</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={ao.articulos}
                    required
                    disabled
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={ao.cantidad}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cbm"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="cbm"
                    value={ao.cbm}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="embarcado"
                    value={ao.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="pendiente_embarcar"
                    value={ao.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precioOriginal"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="PrecioOriginal"
                    value={ao.precioOriginal}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={ao.precio}
                    style={
                      ao.precioOriginal < ao.precio
                        ? { backgroundColor: "#ed8c8c" } // rojo cuando sube
                        : ao.precio < ao.precioOriginal
                        ? { backgroundColor: "#a4e6a4" } // verde cuando baja
                        : {}
                    }
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={ao.total}
                    disabled
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {/* {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.SKU}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))} */}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US").format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal CxP Laredo */}
      <Modal size="lg" isOpen={modalCxPLaredo} toggle={toggleCxPLaredo}>
        <ModalHeader toggle={toggleCxPLaredo}>
          Crear CxP Bodega USA — OC #{ocLaredo?.numero}
        </ModalHeader>
        <ModalBody>
          <p>Selecciona los artículos que se están entregando via Bodega USA. El costo se calcula con TC {ocLaredo?.tipoCambio}.</p>
          <table className="table table-sm">
            <thead>
              <tr>
                <th></th>
                <th>Parent</th>
                <th>Nombre</th>
                <th>Cantidad</th>
                <th>Precio USD</th>
                <th>Costo MXN</th>
              </tr>
            </thead>
            <tbody>
              {articulosLaredo.map((a, idx) => (
                <tr key={a._id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={a.checked}
                      onChange={(e) => {
                        const updated = [...articulosLaredo];
                        updated[idx] = { ...a, checked: e.target.checked };
                        setArticulosLaredo(updated);
                      }}
                    />
                  </td>
                  <td>{a.SKU}</td>
                  <td>{a.nombre}</td>
                  <td>{a.cantidad}</td>
                  <td>${new Intl.NumberFormat("en-US", {minimumFractionDigits:2}).format(a.precio)}</td>
                  <td>${new Intl.NumberFormat("en-US", {minimumFractionDigits:2}).format(a.precio * a.cantidad * (ocLaredo?.tipoCambio || 1))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p><strong>Total: ${new Intl.NumberFormat("en-US", {minimumFractionDigits:2}).format(
            articulosLaredo.filter(a => a.checked).reduce((s, a) => s + (a.precio * a.cantidad * (ocLaredo?.tipoCambio || 1)), 0)
          )}</strong></p>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={crearCxPLaredo}>Crear CxP</Button>
          <Button color="secondary" onClick={toggleCxPLaredo}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoOrdenesCompra;
